import styled from '@emotion/styled';
import { EmotionStyledTextAreaViewProps } from './types';
import { getDefaultTextProps } from '../../Text/shared.styles';
import { getColor, getSpace } from '../../../shared';

export const StyledTextArea = styled.textarea<EmotionStyledTextAreaViewProps>`
  position: relative;
  box-sizing: border-box;
  display: block;
  width: inherit;
  border-radius: 4px;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: ${getColor('main-deep-4')};
  padding: ${getSpace('6')} ${getSpace('32')} ${getSpace('6')} ${getSpace('12')};
  min-height: 34px;
  ${getDefaultTextProps({ size: 14 })};

  &::placeholder {
    color: ${getColor('main-deep-3')};
  }

  &:hover,
  &:focus {
    border: 1px solid ${getColor('main-deep-4')};
    box-shadow: 0 0 5px 1px ${getColor('main-deep-2')};
  }

  ${({ error }) =>
    error &&
    `
    color: ${getColor('error-deep-3')};
    border-color: ${getColor('error-deep-3')};
    box-shadow: 0px 0px 5px 1px ${getColor('error-deep-3')};

    &:focus,&:hover {
      border-color: ${getColor('error-deep-3')};
      box-shadow: 0px 0px 5px 1px ${getColor('error-deep-3')};
    }

    &::placeholder {
      color: ${getColor('error-deep-3')};
    }
  `}

  &:disabled {
    background-color: ${getColor('main-deep-1')};
    cursor: not-allowed;
    color: ${getColor('main-deep-4')};
    border-color: transparent;
    pointer-events: none;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 16px;
  }
`;
